import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  containerCenter: {
    alignItems: 'center',
  },
  giftContainer: {
    marginTop: 55,
    marginBottom: 60,
  },
  tickContainer: {
    marginTop: 90,
    marginBottom: 56,
  },
  failedContainer: {
    marginTop: 25,
  },
  paymentContainer: {
    marginTop: 120,
    marginBottom: 130,
  },
  voucherCodeContainer: {
    marginTop: 156,
    marginBottom: 70,
  },
  paymentErrorContainer: {
    marginTop: 100,
    marginBottom: 227,
  },
  responseTitle: theme => ({
    fontSize: Platform.OS === 'ios' ? 25 : 24,
    fontWeight: 'bold',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: theme.colors.textColorThree,
    marginTop: 15,
    marginBottom: 17,
  }),
  giftTitle: {
    marginTop: 33.1,
    marginBottom: 10,
    width: '80%',
    textAlign: 'center',
  },
  subTitle: (theme, isLoadingError) => ({
    fontSize: 17,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 23,
    letterSpacing: 0,
    color: isLoadingError ? theme.colors.subtitle : theme.colors.textColorThree,
    width: '100%',
    paddingHorizontal: 1,
    marginTop: isLoadingError ? 15 : 0,
  }),
  paymentSubTitle: theme => ({
    marginTop: 12,
    fontSize: 17,
    color: theme.colors.loadingTextColor,
    textAlign: 'center',
  }),
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginTop: 13.5,
  },
  sourceImage: isLoadingError => ({
    width: isLoadingError ? 92 : Platform.OS === 'ios' ? 130 : 110,
    height: isLoadingError ? 92 : Platform.OS === 'ios' ? 130 : 110,
    marginTop: isLoadingError ? 0 : 35,
  }),
  alignCenter: {
    textAlign: 'center',
  },
  lottieView: isPaymentRequest => ({
    width: isPaymentRequest ? 162 : 125,
    height: isPaymentRequest ? 162 : 125,
    alignItems: 'center',
  }),
  rewardLottieViewStyle: {
    width: 156,
    height: 156,
  },
  tryButton: {
    marginTop: 30,
    flexDirection: 'row',
    alignItems: 'center',
  },
  txtButton: theme => ({
    color: theme.colors.activeTabColor,
    fontSize: Platform.OS === 'ios' ? 14.6 : 14,
  }),
  iconButton: {
    marginLeft: 5,
    marginTop: -4,
    alignItems: 'center',
  },
});
